// Default header + footer config. Editable in Admin → Site → Header & Footer.
export const DEFAULT_CHROME = {
  header: {
    logo_image: "",
    logo_text_1: "CG",
    logo_text_2: "Labz",
    menu: [
      { label: "Home", to: "/", children: [] },
      { label: "Science", to: "/peptides", children: [] },
      { label: "Protocols", to: "/tools/match", children: [] },
      {
        label: "Products", to: "/shop", children: [
          { label: "All Products", to: "/shop" },
          { label: "Cases & Accessories", to: "/shop/cases" },
          { label: "COA Library", to: "/coa" },
        ],
      },
      { label: "Journal", to: "/journal", children: [] },
      { label: "Wholesale", to: "/wholesale", children: [] },
      { label: "Partners", to: "/partners", children: [] },
    ],
  },
  footer: {
    logo_image: "", logo_text_1: "CG", logo_text_2: "Labz",
    tagline: "Peptides for a higher you",
    description: "Precision peptide research. Obsessive batch verification. The luxury laboratory.",
    disclaimer: "All products are for laboratory research only. Not for human consumption. Not medical advice.",
    columns: [
      { heading: "Explore", links: [{ label: "All Peptides", to: "/peptides" }, { label: "Shop", to: "/shop" }, { label: "Bulk", to: "/bulk" }, { label: "Compare", to: "/tools/compare" }, { label: "COA Library", to: "/coa" }] },
      { heading: "Tools", links: [{ label: "Precision Calculator", to: "/tools/calculator" }, { label: "Converter", to: "/tools/converter" }, { label: "Research Match", to: "/tools/match" }] },
      { heading: "Company", links: [{ label: "Wholesale", to: "/wholesale" }, { label: "Partners", to: "/partners" }, { label: "Journal", to: "/journal" }, { label: "My Lab", to: "/my-lab" }, { label: "Admin", to: "/admin" }] },
    ],
    bottom_left: "© 2026 CG LABZ. ALL RIGHTS RESERVED.",
    bottom_right: "RESEARCH USE ONLY.",
  },
};

export const mergeChrome = (data = {}) => ({
  header: {
    ...DEFAULT_CHROME.header,
    ...(data.header || {}),
    menu: data.header?.menu?.length ? data.header.menu : DEFAULT_CHROME.header.menu,
  },
  footer: {
    ...DEFAULT_CHROME.footer,
    ...(data.footer || {}),
    columns: data.footer?.columns?.length ? data.footer.columns : DEFAULT_CHROME.footer.columns,
  },
});
